import React from 'react';
import { Routes, Route } from 'react-router-dom';
import App from './App';
import DeepLinkRouter from './DeepLinkRouter';
import MagicLinkHandler from './MagicLinkHandler';

export default function AppRouter() {
  return (
    <Routes>

      {/* ── Existing cardscan route (unchanged) ─────────────────── */}
      <Route path="/cardscan/:cardId" element={<App />} />

      {/* ── Magic link route ─────────────────────────────────────── */}
      {/* Matches: /mlink/{param1} */}
      {/* Example: /mlink/NmEyNzk5YzZjY2QzNWFlZDk2YTdlMTk3         */}
      <Route path="/mlink/:param1" element={<MagicLinkHandler />} />

      {/* ── Full QR deep link route ──────────────────────────────── */}
      {/* Matches: /rewardstick/{OrgID}/{LocationID}/{ActionKey}/{AppID}/{TillNo}/... */}
      <Route
        path="/rewardstick/:orgId/:locationId/:actionKey/:appId/:tillNo/*"
        element={<DeepLinkRouter />}
      />

      {/* ── Root / catch-all ─────────────────────────────────────── */}
      <Route path="*" element={<App />} />

    </Routes>
  );
}
